import React from "react";
import { useNavigate } from "react-router-dom";
import { formatDate, parseCategories, getImageUrl } from "../utils/helpers";
import { InlineShareButtons } from "./ShareButton";

const IndiaWorldNewsSection = ({
  indiaNews,
  worldNews,
  indiaHeading,
  worldHeading,
  lang,
  imageVersion,
}) => {
  const navigate = useNavigate();

  const handleCardKeyPress = (e, slug) => {
    if (e.key === "Enter" || e.key === " ") {
      navigate(`/news/${slug}`);
    }
  };

  if ((!indiaNews || indiaNews.length === 0) && (!worldNews || worldNews.length === 0)) return null;

  return (
    <div className="bg-orange-50 py-8">
      <div className="container mx-auto px-4 grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Left side: India News - 4 small cards in 2x2 grid */}
        <div className="lg:col-span-2">
          <h2 className="text-3xl font-bold mb-6 border-b-4 border-orange-600 pb-3 inline-block text-transparent bg-clip-text bg-gradient-to-r from-orange-600 to-red-600">
            {indiaHeading}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
            {(indiaNews || []).slice(0, 4).map((article) => (
              <div
                key={article.id}
                role="button"
                tabIndex={0}
                onKeyPress={(e) => handleCardKeyPress(e, article.slug)}
                onClick={() => navigate(`/news/${article.slug}`)}
                className="bg-white rounded-xl shadow-md overflow-hidden transform hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer group"
              >
                <div className="relative flex-shrink-0">
                  <div className="overflow-hidden h-40">
                    <img
                      src={
                        article.image && article.image.length > 0
                          ? `${article.image[0]}?v=${imageVersion}`
                          : getImageUrl(
                              article,
                              (() => {
                                const categories = parseCategories(article.categories);
                                return categories.length > 0 ? categories[0] : "News";
                              })(),
                              imageVersion
                            )
                      }
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="absolute top-2 left-2 z-10">
                    <span className="text-xs font-bold text-white bg-gradient-to-r from-orange-600 to-red-600 px-3 py-1 rounded-full">
                      {(parseCategories(article.categories) || [])[0] || "News"}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-bold mb-2 line-clamp-2 text-sm">
                    {article.title}
                  </h3>
                  <div className="flex items-center justify-between mt-2">
                    <p className="text-xs text-gray-600">{formatDate(article.createdAt)}</p>
                    <InlineShareButtons
                      url={`${window.location.origin}/news/${article.slug}`}
                      title={article.title}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right side: World News - vertical list like Trending */}
        <div>
          <h2 className="text-3xl font-bold mb-6 border-b-4 border-amber-600 pb-3 inline-block text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-red-600">
            {worldHeading}
          </h2>
          <div className="space-y-4 mt-6">
            {(worldNews || []).slice(0, 6).map((article) => (
              <div
                key={article.id}
                role="button"
                tabIndex={0}
                onKeyPress={(e) => handleCardKeyPress(e, article.slug)}
                onClick={() => navigate(`/news/${article.slug}`)}
                className="relative rounded-lg cursor-pointer p-2 hover:bg-orange-100 transition-colors flex items-start space-x-4"
              >
                <div className="w-24 h-16 flex-shrink-0 relative rounded overflow-hidden">
                  <img
                    src={
                      article.image && article.image.length > 0
                        ? `${article.image[0]}?v=${imageVersion}`
                        : getImageUrl(article, "World", imageVersion)
                    }
                    alt={article.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="mb-1 flex flex-wrap gap-1">
                    {(parseCategories(article.categories) || []).map((c, idx) => (
                      <span
                        key={idx}
                        className="text-[10px] font-semibold text-red-600 bg-red-100 px-2 py-0.5 rounded-full capitalize"
                      >
                        {c}
                      </span>
                    ))}
                  </div>
                  <h4 className="font-semibold leading-tight">
                    {article.title}
                  </h4>
                  <div className="flex items-center justify-between mt-1">
                    <p className="text-xs text-gray-500">
                      {formatDate(article.createdAt)}
                    </p>
                    <InlineShareButtons
                      url={`${window.location.origin}/news/${article.slug}`}
                      title={article.title}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndiaWorldNewsSection;
